(function () {
  'use strict';

  function storageList() {
    try {
      return JSON.parse(localStorage.getItem('ihn-wishlist') || '[]');
    } catch (error) {
      return [];
    }
  }

  function setWishlist(button, active) {
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
    var label = button.querySelector('[data-wishlist-label]');
    if (label) label.textContent = active ? 'Bewaard' : 'Bewaar';
  }

  function debounce(callback, delay) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { callback.apply(null, args); }, delay);
    };
  }

  function resultImage(item) {
    if (!item || !item.image) return '';
    if (typeof item.image === 'string') return item.image;
    return item.image.url || item.image.src || '';
  }

  function appendSearchResult(container, item, type) {
    var link = document.createElement('a');
    link.className = 'ihn-search-result';
    link.href = item.url;
    link.setAttribute('role', 'option');

    var imageUrl = resultImage(item);
    if (imageUrl) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.width = 72;
      image.height = 72;
      image.loading = 'lazy';
      link.appendChild(image);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'ihn-search-result__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.textContent = type === 'product' ? '◇' : '→';
      link.appendChild(placeholder);
    }

    var copy = document.createElement('span');
    copy.className = 'ihn-search-result__copy';
    var kind = document.createElement('small');
    kind.textContent = type === 'product' ? 'Product' : type === 'collection' ? 'Collectie' : 'Pagina';
    var title = document.createElement('strong');
    title.textContent = item.title || item.name || '';
    copy.appendChild(kind);
    copy.appendChild(title);
    if (item.price) {
      var price = document.createElement('span');
      var numericPrice = Number(item.price);
      price.textContent = Number.isFinite(numericPrice)
        ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(numericPrice)
        : item.price;
      copy.appendChild(price);
    }
    link.appendChild(copy);
    container.appendChild(link);
  }

  function initSearch(form) {
    var input = form.querySelector('input[type="search"]');
    var panel = form.querySelector('[data-ihn-search-results]');
    var output = form.querySelector('[data-ihn-search-output]');
    var popular = form.querySelector('[data-ihn-search-popular]');
    if (!input || !panel || !output) return;

    var requestId = 0;
    function openPanel() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
    function showPopular() {
      output.textContent = '';
      if (popular) popular.hidden = false;
      openPanel();
    }

    var search = debounce(function () {
      var query = input.value.trim();
      if (!query) {
        showPopular();
        return;
      }
      var activeRequest = ++requestId;
      var url = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      url += 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          if (activeRequest !== requestId) return;
          output.textContent = '';
          if (popular) popular.hidden = true;
          var results = data && data.resources && data.resources.results ? data.resources.results : {};
          var count = 0;
          ['products', 'collections', 'pages'].forEach(function (key) {
            (results[key] || []).forEach(function (item) {
              appendSearchResult(output, item, key.slice(0, -1));
              count += 1;
            });
          });
          if (!count) {
            var empty = document.createElement('p');
            empty.className = 'ihn-search-empty';
            empty.textContent = 'Geen directe resultaten. Druk op Enter om uitgebreider te zoeken.';
            output.appendChild(empty);
          }
          openPanel();
        })
        .catch(function () {
          closePanel();
        });
    }, 220);

    input.addEventListener('focus', function () {
      if (!input.value.trim()) showPopular();
      else search();
    });
    input.addEventListener('input', search);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanel();
        input.blur();
      }
    });
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closePanel();
    });
  }

  function initMeasurementForm(form) {
    var input = form.querySelector('input[type="number"]');
    var status = form.querySelector('[data-ihn-measure-status]');
    var type = form.getAttribute('data-measure-type') === 'treden' ? 'treden' : 'm2';
    var key = 'ihn-measure-' + type;
    if (!input) return;

    try {
      var queryValue = new URLSearchParams(window.location.search).get(type);
      var savedValue = localStorage.getItem(key);
      if (queryValue || savedValue) input.value = queryValue || savedValue;
    } catch (error) {}

    function syncLinks(value) {
      document.querySelectorAll('[data-ihn-measured-link]').forEach(function (link) {
        try {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set(type, value);
          link.href = url.pathname + url.search + url.hash;
        } catch (error) {}
      });
    }

    if (input.value) syncLinks(input.value);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = String(input.value || '').trim();
      if (!value || Number(value) <= 0) {
        if (status) status.textContent = 'Vul een geldig aantal in.';
        input.focus();
        return;
      }
      try { localStorage.setItem(key, value); } catch (error) {}
      syncLinks(value);
      if (status) status.textContent = type === 'm2'
        ? value.replace('.', ',') + ' m² is bewaard voor uw productkeuze.'
        : value + ' treden is bewaard voor uw keuze.';
    });
  }

  function initCarousel(shell) {
    var track = shell.querySelector('[data-ihn-carousel]');
    var previous = shell.querySelector('[data-ihn-carousel-prev]');
    var next = shell.querySelector('[data-ihn-carousel-next]');
    if (!track || !previous || !next || track.children.length < 2) return;

    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 900px)');

    function stepSize() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return first.getBoundingClientRect().width + gap;
    }

    function move(direction) {
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var target = track.scrollLeft + (stepSize() * direction);
      if (direction > 0 && target >= maximum - 8) target = maximum;
      if (direction > 0 && track.scrollLeft >= maximum - 8) target = 0;
      if (direction < 0 && track.scrollLeft <= 8) target = maximum;
      track.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!track.hasAttribute('data-ihn-carousel-autoplay') || !mobile.matches || reduceMotion.matches) return;
      timer = window.setInterval(function () { move(1); }, 4200);
    }

    previous.addEventListener('click', function () { move(-1); start(); });
    next.addEventListener('click', function () { move(1); start(); });
    shell.addEventListener('mouseenter', stop);
    shell.addEventListener('mouseleave', start);
    shell.addEventListener('focusin', stop);
    shell.addEventListener('focusout', start);
    shell.addEventListener('touchstart', stop, { passive: true });
    shell.addEventListener('touchend', start, { passive: true });
    mobile.addEventListener('change', start);
    reduceMotion.addEventListener('change', start);
    start();
  }

  function pushCommerceEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name, event_source: 'interieurhuis_theme' };
    Object.keys(details || {}).forEach(function (key) { payload[key] = details[key]; });
    window.dataLayer.push(payload);
  }

  function pageKind() {
    var path = window.location.pathname;
    if (path === '/') return 'home';
    if (path.indexOf('/products/') === 0) return path === '/pages/showroomafspraak' ? 'booking' : 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/pages/offerte') === 0) return 'quote';
    return path.indexOf('/pages/') === 0 ? 'page' : 'other';
  }

  function initConversionSignals() {
    if (document.querySelector('.product-section[data-product-handle="showroom"]')) {
      document.body.classList.add('ihn-showroom-product');
    }
    var important = /offerte|showroom|agenda|bestel|winkelwagen|afrekenen|advies/i;
    document.querySelectorAll('a.ihn-btn,button.ihn-btn,a.btn,button.btn').forEach(function (element) {
      if (important.test(element.textContent || '')) element.classList.add('ihn-animated-cta');
    });

    pushCommerceEvent('ihn_page_view', {
      page_type: pageKind(),
      page_path: window.location.pathname,
      page_title: document.title
    });

    document.addEventListener('click', function (event) {
      var target = event.target.closest('a,button');
      if (!target) return;
      var text = (target.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
      var href = target.getAttribute('href') || '';

      if (target.matches('[data-ihn-booking-start],.meety-block-schedule-button') || /showroom|agenda/i.test(text)) {
        pushCommerceEvent('ihn_booking_start', { link_text: text, destination: href });
      } else if (/offerte/i.test(text) || href.indexOf('/pages/offerte') !== -1) {
        pushCommerceEvent('ihn_quote_start', { link_text: text, destination: href });
      } else if (target.matches('[data-ihn-category]')) {
        pushCommerceEvent('ihn_category_click', { category_name: target.getAttribute('data-ihn-category'), destination: href });
      } else if (target.closest('.ihn-whatsapp-float') || href.indexOf('wa.me') !== -1) {
        pushCommerceEvent('ihn_whatsapp_click', { destination: href });
      } else if (important.test(text)) {
        pushCommerceEvent('ihn_cta_click', { link_text: text, destination: href });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="/cart/add"]')) pushCommerceEvent('ihn_add_to_cart', { page_path: window.location.pathname });
      if (form.closest('[data-ihn-offerte],.ihn-offerte,.ihn-offerte-form') || /offerte/i.test(form.id || '')) pushCommerceEvent('ihn_quote_submit', { form_id: form.id || '' });
    }, true);

    var bookingObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        var content = record.target && record.target.textContent ? record.target.textContent : '';
        if (/appointment (is )?confirmed|booking confirmed|afspraak (is )?bevestigd|bedankt voor uw boeking/i.test(content)) {
          pushCommerceEvent('ihn_booking_success', { page_path: window.location.pathname });
          bookingObserver.disconnect();
        }
      });
    });
    bookingObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ihn-mobile-menu').forEach(function (menu) {
      var summary = menu.querySelector('summary');
      var syncMenuLabel = function () {
        if (summary) summary.setAttribute('aria-label', menu.open ? 'Sluit menu' : 'Open menu');
        document.documentElement.classList.toggle('ihn-menu-is-open', menu.open);
      };
      menu.addEventListener('toggle', syncMenuLabel);
      syncMenuLabel();
    });

    document.querySelectorAll('[data-ihn-search]').forEach(initSearch);
    document.querySelectorAll('[data-ihn-measure-form]').forEach(initMeasurementForm);
    document.querySelectorAll('.ihn-carousel-shell').forEach(initCarousel);
    initConversionSignals();

    var mobileSearch = document.querySelector('[data-ihn-mobile-search]');
    var mobileSearchButton = document.querySelector('[data-ihn-search-open]');
    if (mobileSearch && mobileSearchButton) {
      mobileSearchButton.addEventListener('click', function () {
        var opening = mobileSearch.hidden;
        mobileSearch.hidden = !opening;
        mobileSearchButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          var searchInput = mobileSearch.querySelector('input[type="search"]');
          if (searchInput) window.setTimeout(function () { searchInput.focus(); }, 40);
        }
      });
    }

    document.querySelectorAll('[data-ihn-wishlist]').forEach(function (button) {
      var handle = button.getAttribute('data-ihn-wishlist');
      setWishlist(button, storageList().indexOf(handle) !== -1);
      button.addEventListener('click', function () {
        var items = storageList();
        var index = items.indexOf(handle);
        if (index === -1) items.push(handle);
        else items.splice(index, 1);
        try { localStorage.setItem('ihn-wishlist', JSON.stringify(items)); } catch (error) {}
        setWishlist(button, index === -1);
      });
    });

    document.querySelectorAll('.ihn-mobile-menu a').forEach(function (link) {
      link.addEventListener('click', function () {
        var menu = link.closest('details');
        if (menu) menu.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.ihn-mobile-menu[open]').forEach(function (menu) { menu.removeAttribute('open'); });
      if (mobileSearch && !mobileSearch.hidden) {
        mobileSearch.hidden = true;
        if (mobileSearchButton) mobileSearchButton.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();
